import { app } from '../../../app';
import { Controller } from './client-saml-login.controller';

app.component('loginSamlClientSso', {
    controller: Controller,
    templateUrl: require('../saml-login/saml-login.html'),
});


// WEBPACK FOOTER //
// ./src/portal/states/public/client-saml-login/client-saml-login.component.js